var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgIcXMi24 = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#ic-x-mi-24_svg__a)"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#E9620B",
  d: "M11.824 23.994c-1.904-.024-3.807-.038-5.687-.44A7.39 7.39 0 0 1 .29 17.597 30.5 30.5 0 0 1 .296 6.491C.918 3.212 2.993 1.201 6.23.481c2.874-.63 5.789-.515 8.708-.356 1.66.091 3.269.406 4.758 1.221 1.96 1.083 3.092 2.787 3.583 4.931.645 2.823.532 5.693.414 8.557a13.2 13.2 0 0 1-.695 3.892 7.05 7.05 0 0 1-4.437 4.486c-1.73.637-3.533.721-5.347.784-.463.01-.928-.002-1.389-.002"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M19.016 7.502h-2a.156.156 0 0 0-.156.153v9.175c0 .086.07.155.155.156h2.001a.156.156 0 0 0 .154-.156V7.654a.153.153 0 0 0-.154-.154M12.172 7.502H4.536a.153.153 0 0 0-.153.153v9.175c0 .085.069.155.153.156h2.001a.16.16 0 0 0 .156-.156V9.639a.16.16 0 0 1 .156-.156h4.318a1.464 1.464 0 0 1 1.562 1.528v5.818c.001.086.07.155.156.156h2a.156.156 0 0 0 .154-.156v-6.51a2.59 2.59 0 0 0-.749-1.983 2.67 2.67 0 0 0-2.111-.834"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M10.769 11.151H8.658a.156.156 0 0 0-.154.154v5.525c0 .085.069.154.154.154h2.111a.156.156 0 0 0 .156-.154V11.3a.16.16 0 0 0-.156-.153"
}))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "ic-x-mi-24_svg__a"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M0 0h24v24H0z"
})))));
export default SvgIcXMi24;